<template>
    <div>not found-404</div>
</template>
<script>
export default {
    data(){
        return{

        }
    }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/notFound/notFound.vue